import { Badge } from "@/components/ui/badge";
import { isFeatureEnabled } from "@/lib/analytics";
import { isEvalOpsStaff } from "@/lib/utils/user";
import { useAuth } from "@/lib/auth/useAuth";
import { useEffect } from "react";
import { useUser } from '@/lib/contexts/UserContext';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function StaffBadge() {
  const { user: authUser } = useAuth();
  const { user } = useUser();
  
  useEffect(() => {
    if (import.meta.env.DEV) {
      console.log("StaffBadge - Auth User:", authUser);
      console.log("StaffBadge - Is Staff:", authUser ? isEvalOpsStaff(authUser.email) : false);
      console.log("StaffBadge - Feature Flag Enabled:", isFeatureEnabled('staff-badge'));
    }
  }, [authUser]);
  
  if (!authUser || !user || !isEvalOpsStaff(authUser.email) || !isFeatureEnabled('staff-badge')) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="inline-block">
            <Badge 
              variant="secondary" 
              className="bg-purple-100 text-purple-800 hover:bg-purple-200 cursor-help"
            >
              Staff
            </Badge>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="center" className="w-[300px] p-0 overflow-hidden">
          <div className="p-3 max-h-[300px] overflow-y-auto">
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium">User Profile</h3>
                <ul className="mt-2 space-y-1 text-xs">
                  <li className="flex justify-between">
                    <span className="text-muted-foreground">ID:</span>
                    <span className="font-mono">{user.id}</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-muted-foreground">Name:</span>
                    <span>{user.name}</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-muted-foreground">Email:</span>
                    <span>{user.email}</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-muted-foreground">Role:</span>
                    <span>{user.role}</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-muted-foreground">Staff:</span>
                    <span>{user.metadata?.is_staff === 'true' ? 'Yes' : 'No'}</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-muted-foreground">Onboarding:</span>
                    <span>{user.onboarding_completed ? 'Completed' : 'Pending'}</span>
                  </li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-sm font-medium">Auth Info</h3>
                <ul className="mt-2 space-y-1 text-xs">
                  <li className="flex justify-between">
                    <span className="text-muted-foreground">Auth ID:</span>
                    <span className="font-mono">{authUser.id.substring(0, 10)}...</span>
                  </li>
                  {authUser.firstName && (
                    <li className="flex justify-between">
                      <span className="text-muted-foreground">First Name:</span>
                      <span>{authUser.firstName}</span>
                    </li>
                  )}
                  {authUser.lastName && (
                    <li className="flex justify-between">
                      <span className="text-muted-foreground">Last Name:</span>
                      <span>{authUser.lastName}</span>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
} 